// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc397a14","455":"a16be92e","977":"ad1a037e"}[chunkId] + ".chunk.js";
};